import { Component } from '@angular/core';
import { EnumHelper } from '../../../../../helpers/enum.helper';
import { ADBInfo, D365DBInfo, DBPanelInfo } from '../../../../../models/datamodel/adbinfo.model';
import { CDataD365Edition } from '../../../../../models/enums/cdatad365edition.enum';
import { BaseDataSourcePanel } from '../basedatasource.panel';

@Component({
    selector: 'dynamics365-panel',
    templateUrl: './dynamics365.panel.html'
})
export class Dynamics365Panel extends BaseDataSourcePanel {
    Editions = [];
    constructor() {
        super();
        this.DBInfoType = D365DBInfo;
        this.Editions = EnumHelper.GetDropdownValues(CDataD365Edition);
    }

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: Dynamics365Panel,
            DBInfoType: D365DBInfo
        };
    }
}
